module.exports = __webpack_public_path__ + "fonts/regular.241ca81.ttf";